import React from 'react';
import { Link } from 'react-scroll'
import Logo from '../../images/alza_logo.png';

const Header = () => {
    return (
        <>
            {/* Duyuru Şeridi */}
            <div className="announcement-bar">
                <p>Yeni Yüzümüz ile Karşınızdayız.</p>
            </div>

            {/* Yeni Header */}
            <header className="main-header">
                <div className="container-fluid">
                    <div className="header-content">
                        <div className="logo">
                            <img src={Logo} alt="Alza Logo" />
                        </div>
                        <nav className="main-nav">
                            <ul>
                                <li>
                                    <Link activeClass="active" to="home" spy={true} smooth={true} duration={500}>
                                        Anasayfa
                                    </Link>
                                </li>
                                <li>
                                    <Link activeClass="active" to="about" spy={true} smooth={true} duration={500}>
                                        Kurumsal
                                    </Link>
                                </li>
                                <li>
                                    <Link activeClass="active" to="contact" spy={true} smooth={true} duration={500}>
                                        İletişim
                                    </Link>
                                </li>
                                <li>
                                    <Link activeClass="active" to="applications" spy={true} smooth={true} duration={500}>
                                        Başvurular
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </header>
        </>
    );
}

export default Header;